module.exports = __webpack_public_path__ + "img/mobile.141d37b7.png";